import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { User, Building2 } from 'lucide-react';
import api from '@/lib/api';
import { formatDate } from '@/lib/datetime';

export default function CustomerProfile() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetch = async () => {
            try {
                const res = await api.get('/customer/profile');
                setData(res.data.data);
            } catch {} finally { setLoading(false); }
        };
        fetch();
    }, []);

    if (loading) return <p className="text-white/60 text-center py-8">Cargando...</p>;
    if (!data) return <p className="text-white/60 text-center py-8">No se encontró perfil.</p>;

    const { user, customer } = data;

    return (
        <div>
            <h1 className="text-2xl font-bold uppercase tracking-wide mb-6">Mi Perfil</h1>

            <div className="grid gap-6 md:grid-cols-2">
                <Card className="bg-[#0a0a0a] border-hairline-dark">
                    <CardHeader className="flex flex-row items-center gap-3">
                        <div className="h-10 w-10 bg-white/10 rounded-full flex items-center justify-center">
                            <User className="h-5 w-5 text-white" />
                        </div>
                        <CardTitle>Datos Personales</CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-3">
                        <div className="flex justify-between">
                            <span className="text-white/60">Nombre</span>
                            <span className="font-medium">{customer.first_name} {customer.last_name}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-white/60">DNI</span>
                            <span className="font-mono">{customer.dni}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-white/60">Email</span>
                            <span>{customer.email || user.email || '-'}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-white/60">Teléfono</span>
                            <span>{customer.phone || user.phone || '-'}</span>
                        </div>
                        {customer.birth_date && (
                            <div className="flex justify-between">
                                <span className="text-white/60">Fecha de nacimiento</span>
                                <span>{formatDate(customer.birth_date)}</span>
                            </div>
                        )}
                    </CardContent>
                </Card>

                <Card className="bg-[#0a0a0a] border-hairline-dark">
                    <CardHeader className="flex flex-row items-center gap-3">
                        <div className="h-10 w-10 bg-white/10 rounded-full flex items-center justify-center">
                            <Building2 className="h-5 w-5 text-white" />
                        </div>
                        <CardTitle>Mi Gimnasio</CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-3">
                        {customer.gym ? (
                            <>
                                <div className="flex items-center gap-3">
                                    {customer.gym.logo ? (
                                        <img src={`/storage/${customer.gym.logo}`} alt="Logo" className="h-12 w-12 object-contain rounded-lg border border-hairline-dark" />
                                    ) : (
                                        <div className="h-12 w-12 bg-[#0a0a0a] rounded-lg flex items-center justify-center border border-hairline-dark">
                                            <Building2 className="h-6 w-6 text-white/60" />
                                        </div>
                                    )}
                                    <div>
                                        <p className="font-semibold">{customer.gym.name}</p>
                                        {customer.gym.address && <p className="text-sm text-white/60">{customer.gym.address}</p>}
                                    </div>
                                </div>
                                {customer.gym.phone && (
                                    <div className="flex justify-between">
                                        <span className="text-white/60">Teléfono</span>
                                        <span>{customer.gym.phone}</span>
                                    </div>
                                )}
                                {customer.gym.email && (
                                    <div className="flex justify-between">
                                        <span className="text-white/60">Email</span>
                                        <span>{customer.gym.email}</span>
                                    </div>
                                )}
                            </>
                        ) : (
                            <p className="text-white/60">Sin gimnasio asignado.</p>
                        )}

                        {customer.active_card && (
                            <div className="mt-4 p-3 bg-[#0a0a0a] rounded-lg border border-hairline-dark">
                                <div className="flex items-center justify-between">
                                    <span className="text-sm font-medium text-white">Tarjeta Activa</span>
                                    <Badge variant="success">Activa</Badge>
                                </div>
                                <p className="text-xs text-white/60 mt-1">
                                    Válida hasta {formatDate(customer.active_card.end_date)}
                                </p>
                            </div>
                        )}
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
